import { apiRequest } from '@/core';
import { type UpdateMemberPayload } from '@/slices/members/types';

export const updateMemberRequest = async ({
  is_public,
  memberId,
}: UpdateMemberPayload) =>
  apiRequest<void>({
    endpoint: `api/members/${memberId}`,
    method: 'PATCH',
    body: { is_public },
  });
